export default __webpack_public_path__ + "static/media/TermsOfService.en.7098da13.md";